define('SuiteDynamics.InsertsExtension.ProductViews.Price.View.Extended',
    [
        'underscore',
        'bignumber',
        'SC.Configuration',
        'Profile.Model',
        'ProductViews.Price.View',
        'SuiteDynamics.Inserts.Collection',
    ],
    function (
        _,
        bignumber,
        SCConfiguration,
        ProfileModel,
        ProductViewsPriceView,
        InsertsCollection
    )
{
    'use strict';

    ProductViewsPriceView.prototype.initialize = _.wrap(ProductViewsPriceView.prototype.initialize, function(originalFn) {
        originalFn.apply(this, _.toArray(arguments).slice(1));
        var isProductView = this.options.origin && (this.options.origin === 'PDPFULL' || this.options.origin === 'PDPQUICK');
        if (isProductView) {
            this.model.on('change', _.bind(this.evaluateProductPrice, this));
        }

        if (this.isB2B()) {
            var insertIds = this.getInsertIds();
            if (insertIds) {
                var self = this;
                this.getInsertItems(insertIds).done(function(insertItems) {
                    self.insertPrices = {};
                    _.each((insertIds || '').split(','), function(insertId) {
                        var insertItem = insertItems[parseInt(insertId)];
                        if (insertItem) {
                            if (insertItem.matrixchilditems_detail && insertItem.matrixchilditems_detail.length) {
                                var firstChild = insertItem.matrixchilditems_detail[0];
                                self.insertPrices[parseInt(insertItem.internalid)] = firstChild.onlinecustomerprice_detail.onlinecustomerprice;
                            } else {
                                self.insertPrices[parseInt(insertItem.internalid)] = insertItem.onlinecustomerprice_detail.onlinecustomerprice;
                            }
                        }
                    });
                    self.render();
                });
            }
        }
    });

    ProductViewsPriceView.prototype.destroy = _.wrap(ProductViewsPriceView.prototype.destroy, function(originalFn) {
        this.model.off('change', _.bind(this.evaluateProductPrice, this));
        originalFn.apply(this, _.toArray(arguments).slice(1));
    });

    ProductViewsPriceView.prototype.evaluateProductPrice = function() {
        var selectedInsertsOption = this.model.get('custcol_ano_inserts_internalid');
        if (selectedInsertsOption) {
            var insertsConfig = SCConfiguration.get('insertsExtension.insertsConfiguration', []);
            var shoeType = this.model.get('item') && this.model.get('item').get('class');
            var selectedInsert = _.findWhere(insertsConfig, {
                customersegmentation: this.isB2B() ? 'B2B' :'B2C',
                shoetype: shoeType,
                insertid: selectedInsertsOption
            });

            if (selectedInsert) {
                this.selectedInsertsQty = parseFloat(this.model.get('custcol_ano_inserts_quantity')) || 1;
                if (this.isB2B()) {
                    var price = this.insertPrices && this.insertPrices[selectedInsert.insertid] || 0;
                    this.selectedInsertsPrice = parseFloat(price);
                } else {
                    this.selectedInsertsPrice = parseFloat(selectedInsert.addOnPrice) || 0;
                }
            } else {
                this.selectedInsertsQty = 1;
                this.selectedInsertsPrice = 0;
            }
        }

        this.render();
    }

    ProductViewsPriceView.prototype.isB2B = function() {
        var profileModel = ProfileModel.getInstance();
        var isB2B = false;
        var isLoggedIn = profileModel.get('isLoggedIn') === 'T';

        if (isLoggedIn) {
            var profileCustomFields = profileModel.get('customfields') || [];
            var isB2BField = _.findWhere(profileCustomFields, { name: 'custentity_ano_is_b2b' });
            if (isB2BField && isB2BField.value && isB2BField.value === 'T') {
                isB2B = true;
            }
        }

        return isB2B;
    }

    ProductViewsPriceView.prototype.getInsertIds = function() {
        var insertsConfig = SCConfiguration.get('insertsExtension.insertsConfiguration', []);
        var inserts = _.where(insertsConfig, {
            customersegmentation: this.isB2B() ? 'B2B' : 'B2C',
            shoetype: this.model.get('item') && this.model.get('item').get('class')
        });

        var insertIds = _.pluck(inserts, 'insertid').filter(function(id) {
            return id;
        });

        return insertIds.join(',');
    };

    ProductViewsPriceView.prototype.getInsertItems = function(insertIds) {
        var deferred = jQuery.Deferred();
        var insertItems = {};
        var itemCollection = new InsertsCollection();

        itemCollection.fetch({
            data: {
                id: insertIds
            }
        }).done(function(resp) {
            var items = resp.items;
            _.each(items, function(item) {
                insertItems[item.internalid] = item;
            });
            deferred.resolve(insertItems);
        });

        return deferred;
    };

    ProductViewsPriceView.prototype.getContext = _.wrap(ProductViewsPriceView.prototype.getContext, function(originalFn) {
        var originalContext = originalFn.apply(this, _.toArray(arguments).slice(1));
        var isProductView = this.options.origin && this.options.origin === 'PDPFULL' || this.options.origin === 'PDPQUICK'
        var price = originalContext.price;
        var priceFormatted = originalContext.priceFormatted;
        var comparePrice = originalContext.comparePrice;
        var comparePriceFormatted = originalContext.comparePriceFormatted;

        if (isProductView && this.selectedInsertsQty && this.selectedInsertsPrice) {
            price = bignumber(price).plus(this.selectedInsertsPrice).times(this.selectedInsertsQty).toNumber();
            comparePrice = bignumber(comparePrice).plus(this.selectedInsertsPrice).times(this.selectedInsertsQty).toNumber();

            if (priceFormatted) {
                priceFormatted = addPrice(priceFormatted, this.selectedInsertsPrice, this.selectedInsertsQty);
            }
            if (comparePriceFormatted) {
                comparePriceFormatted = addPrice(comparePriceFormatted, this.selectedInsertsPrice, this.selectedInsertsQty);
            }
        }

        return _.extend(originalContext, {
            price: price,
            priceFormatted: priceFormatted,
            comparePrice: comparePrice,
            comparePriceFormatted: comparePriceFormatted
        });
    });

    function addPrice(originalPrice, addOnPrice, quantity) {
        var currencySymbol = originalPrice.match(/^\D+/)[0].trim();
        var originalPriceNumber = bignumber(originalPrice.replace(/^\D+/, '').trim());
        var addOnPriceNumber = bignumber(addOnPrice).times(quantity);
        var totalPrice = originalPriceNumber.plus(addOnPriceNumber);

        return currencySymbol + totalPrice.toFixed(2);
    }
});
